export default "__VITE_ASSET__DnZPGYg9__"